<template>
    <div class="examine-notice-detail">
        <div class="examin-notice-box" v-loading="pageLoading">
            <div class="widthPC-90 margin-x-auto">
                <div class="fileNo text-right" v-if="baseInfo.fileNo">{{ baseInfo.fileNo }}</div>
                <table class="detail-table" border="1" cellspacing="0" cellpadding="0">
                    <tr>
                        <th colspan="2">节能审查</th>
                    </tr>
                    <tr>
                        <td class="font-bold">项目编号：</td>
                        <td>{{ baseInfo.projectCode }}</td>


                    </tr>
                    <tr>
                        <td class="font-bold">项目名称：</td>
                        <td>{{ baseInfo.projectName }}</td>
                    </tr>
                    <tr v-if="baseInfo.companyName">
                        <td class="font-bold">建设单位：</td>
                        <td><span :class="baseInfo.hasContact && curWebsite.type == 3 ? 'active-color' : ''"
                                @click="baseInfo.hasContact && curWebsite.type == 3 && handlerLinkLocal('/contact/detail?id=' + baseInfo.companyName + '&type=2')">{{
                                baseInfo.companyName || '-' }}</span></td>
                    </tr>
                    <tr>
                        <td class="font-bold">审批单位：</td>
                        <td>{{ baseInfo.handleDeptName }}</td>
                    </tr>
                    <tr>
                        <td class="font-bold">标题：</td>
                        <td>{{ baseInfo.title }}</td>
                    </tr>
                    <tr>
                        <td class="font-bold">项目状态：</td>
                        <td>{{ baseInfo.stateName }}</td>
                    </tr>
                    <tr>
                        <td class="font-bold">有效期：</td>
                        <td>{{ baseInfo.expiryDate || '-' }}</td>
                    </tr>
                    <tr>
                        <td class="font-bold">公开情况：</td>
                        <td>{{ baseInfo.openType || '-' }}</td>
                    </tr>
                    <tr>
                        <td class="font-bold">完成日期：</td>
                        <td>{{ baseInfo.finishDate }}</td>
                    </tr>
                    <tr>
                        <td class="font-bold">是否有效：</td>
                        <td>{{ baseInfo.isValidity ? '是' : '否' || '-' }}</td>
                    </tr>
                    <tr>
                        <td class="font-bold">规模及内容：</td>
                        <td>{{ baseInfo.scaleContent || '-' }}</td>
                    </tr>
                    <tr>
                        <td class="font-bold">抄送：</td>
                        <td>{{ baseInfo.copies }}</td>
                    </tr>
                </table>
                <ad :type="2"></ad>
                <div class="detail-content" v-html="baseInfo.content"></div>
                <!--判断数组长度 -->
                <relatedBy v-if="extend.relatedByProjectCode && extend.relatedByProjectCode.length > 0"
                    :pageTitle="'关联项目'" :pageType="2"
                    :relatedByData="extend.relatedByProjectCode">
                </relatedBy>
                <relatedBy v-if="extend.relatedByCompanyName && extend.relatedByCompanyName.length > 0"
                    :pageTitle="'建设单位（' + baseInfo.companyName + '）关联项目'" :pageType="1" :relatedByData="extend.relatedByCompanyName">
                </relatedBy>
            </div>
        </div>
    </div>
</template>

<script>
import relatedBy from '../components/relatedBy.vue'
export default {
    components: {
        relatedBy
    },

    data() {
        return {
            id: this.$route.query.id || null,
            curWebsite: this.$api.getWebsiteType(),
            pageLoading: false,
            baseInfo: {
                fileNo: '',
                projectName: '',
                projectCode: '',
                approvalUnit: '',
                type: '',
                title: '',
                completionDate: ''
            },
            extend: {}
        }
    },
    created() {

    },
    mounted() {
        this.getData();
    },
    methods: {
        getData() {
            let ajaxUrl = this.$api.common.EnergyNotice.Detail() + '?id=' + this.id;
            this.pageLoading = true;
            this.$axios.get(ajaxUrl).then((res) => {
                this.pageLoading = false;
                console.log('公告数据详情', res);
                this.baseInfo = res.data || {};
                this.extend = res.extend || {};
            }).catch((err) => {
                this.pageLoading = false;
            });

        }
    }
}
</script>

<style lang="less" scoped>
.examin-notice-box {
    padding: 20px;
    width: 100%;
    background: #fff;
}

.fileNo {
    font-size: 20px;
    color: #666;
}

.detail-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 20px;

    th {
        background: #f1f8ff;
        text-align: center;
    }

    th,
    td {
        padding: 10px;
        border: 1px solid #eee;
        min-width: 150px;
    }
}

.detail-content {
    margin-top: 20px;
    padding: 10px;
    line-height: 3;
    border: 1px solid #ebf1f5;
    box-shadow: 0 2px 4px #ebf1f5;
}
</style>